import React from 'react';
import { FaUsers, FaClock, FaCalendarAlt, FaBullseye } from 'react-icons/fa';
import './TourInfo.scss';

const TourInfo = () => {
const infoCards = [
    {
  icon: <FaUsers />,
  title: '신청 대상',
  content: (
    <ul>
      <li>초·중·일반 단체 15인 이상 40인 미만</li>
      <li>고등학생 단체 10인 이상 100인 미만</li>
      <li>고등학생은 입학설명회 신청 시에 한해 가능</li>
    </ul>
  ),
},
{
  icon: <FaClock />,
  title: '소요 시간',
  content: (
    <ul>
      <li>초·중·일반 단체 약 60분</li>
      <li>고등학생 단체 약 80~100분</li>
    </ul>
  ),
},
{
  icon: <FaCalendarAlt />,
  title: '운영 일정',
  content: (
    <ul>
      <li>초·중·일반 단체 금요일 오후 1시 운영</li>
      <li>고등학생 단체 평일 중 신청 가능</li>
      <li>공휴일 및 수시·정시 전형 기간 제외</li>
    </ul>
  ),
},
{
  icon: <FaBullseye />,
  title: '주요 일정',
  content: (
    <ul>
      <li>GIST 학사 제도 소개 및 입학 안내</li>
      <li>홍보 영상 시청</li>
      <li>캠퍼스 주요 시설 투어</li>
      <li>연구실 및 실험실 견학</li>
      <li>질의응답 및 상담</li>
    </ul>
  ),
},
];

return (
    <section className="sec-tour-info">
    <div className="TourInfo">
        <div className="box-main">
        <h2 className="info-title">투어 안내</h2>
        <div className="box-cards">
            {infoCards.map((card, index) => (
            <article key={index} className="art-info-card">
                <div className="card-header">
                    <div className="box-icon">{card.icon}</div>
                    <h3 className="card-title2">{card.title}</h3>
                </div>
                <div className="card-content">{card.content}</div>
            </article>
            ))}
        </div>
        </div>
    </div>
    </section>
);
};

export default TourInfo;